import { render } from "./NoData.vue?vue&type=template&id=ce308d54&scoped=true"
import script from "./NoData.vue?vue&type=script&lang=js"
export * from "./NoData.vue?vue&type=script&lang=js"

import "./NoData.vue?vue&type=style&index=0&id=ce308d54&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ce308d54"]])

export default __exports__